module.exports = __webpack_public_path__ + "static/cursosImage1-46c80bb1b0aaf3a1ef972ed58c83697a.jpg";